import { render, staticRenderFns } from "./RequisitionSampleMenu.vue?vue&type=template&id=9abfb13a&"
import script from "./RequisitionSampleMenu.vue?vue&type=script&lang=js&"
export * from "./RequisitionSampleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports